import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleAnimatedVideo, animatedVideoList, changeSingleAnimatedVideoStatus, deleteSingleAnimatedVideo, updateSingleAnimatedVideo } from "../apis/apiHandler";

export const animatedVideo = createAsyncThunk(
    "animated_video/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await animatedVideoList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addAnimatedVideo = createAsyncThunk(
    "animated_video/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleAnimatedVideo(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateAnimatedVideo = createAsyncThunk(
    "animated_video/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleAnimatedVideo(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteAnimatedVideo = createAsyncThunk(
    "animated_video/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleAnimatedVideo(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeAnimatedVideoStatus = createAsyncThunk(
    "animated_video/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleAnimatedVideoStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    animatedVideoList: [],
    addAnimatedVideoData: {},
    updateAnimatedVideoData: {},
    deleteAnimatedVideoData: {},
    changeAnimatedVideoStatusData: {},
    error: null,
    success: false,
};

const AnimatedVideoSlice = createSlice({
    name: "blog",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(animatedVideo.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(animatedVideo.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.animatedVideoList = payload;
                state.success = true;
            })
            .addCase(animatedVideo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addAnimatedVideo.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addAnimatedVideo.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addAnimatedVideoData = payload;
                state.success = true;
            })
            .addCase(addAnimatedVideo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateAnimatedVideo.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateAnimatedVideo.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateAnimatedVideoData = payload;
                state.success = true;
            })
            .addCase(updateAnimatedVideo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteAnimatedVideo.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteAnimatedVideo.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteAnimatedVideoData = payload;
                state.success = true;
            })
            .addCase(deleteAnimatedVideo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeAnimatedVideoStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeAnimatedVideoStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeAnimatedVideoStatusData = payload;
                state.success = true;
            })
            .addCase(changeAnimatedVideoStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default AnimatedVideoSlice.reducer;
